import { render, staticRenderFns } from "./IVOnAtStartPanel.vue?vue&type=template&id=30dfcba1&scoped=true&"
import script from "./IVOnAtStartPanel.vue?vue&type=script&lang=js&"
export * from "./IVOnAtStartPanel.vue?vue&type=script&lang=js&"
import style0 from "./IVOnAtStartPanel.vue?vue&type=style&index=0&id=30dfcba1&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30dfcba1",
  null
  
)

export default component.exports